// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__kllMC","bigColWidth":"Table_bigColWidth__3bDUn","biggerColWidth":"Table_biggerColWidth__29Xtd","row":"Table_row__bttfh","col":"Table_col__3xeic"};